/**
 * CallHealthBanners (LUM-82)
 *
 * Mid-call session-health banners. Each shows while its condition
 * holds and clears with it.
 */

import { Alert, Text } from '@mantine/core';
import {
  IconEyeOff,
  IconMicrophoneOff,
  IconWifiOff,
} from '@tabler/icons-react';
import { CALL_BANNER_COPY } from '@/features/interview/call-health';
import type { CallHealthBanners as Banners } from '@/hooks/useCallHealth';

export interface CallHealthBannersProps {
  banners: Banners;
}

export function CallHealthBanners({
  banners,
}: Readonly<CallHealthBannersProps>) {
  return (
    <>
      {banners.tabHidden && (
        <Alert color="blue" variant="light" icon={<IconEyeOff size={16} />}>
          <Text size="sm">{CALL_BANNER_COPY.tabHidden}</Text>
        </Alert>
      )}
      {banners.connectionUnstable && (
        <Alert color="yellow" variant="light" icon={<IconWifiOff size={16} />}>
          <Text size="sm">{CALL_BANNER_COPY.connectionUnstable}</Text>
        </Alert>
      )}
      {banners.micSilent && (
        <Alert
          color="yellow"
          variant="light"
          icon={<IconMicrophoneOff size={16} />}
        >
          <Text size="sm">{CALL_BANNER_COPY.micSilent}</Text>
        </Alert>
      )}
    </>
  );
}
